import { render, staticRenderFns } from "./EventSelectorDesktop.vue?vue&type=template&id=3cb1350f"
import script from "./EventSelectorDesktop.vue?vue&type=script&lang=js"
export * from "./EventSelectorDesktop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports